<template>
   <div>
        <div class="filter-bar">
            <el-form :inline="true" :model="formData">
                <el-form-item label="" label-width="0">
                    <QuarterDate 
                        :min='2024' 
                        v-model="formData.quarter"
                        @change="handleParamsChange"
                    />
                </el-form-item>
                <el-form-item label="媒体：" >
                    <ESelect 
                        v-model="formData.plat_id" 
                        placeholder="请选择" 
                        size="mini" 
                        class="select-tags-width" 
                        @change="handleParamsChange"
                    >
                        <el-option 
                            v-for="item in filterPlatList" 
                            :key="item.id" 
                            :label="item.name" 
                            :value="item.id"
                        />
                    </ESelect>
                </el-form-item>
                <el-form-item label="销售组：" >
                    <ESelect 
                        v-model="formData.groups" 
                        placeholder="请选择" 
                        size="mini" 
                        class="select-tags-width" 
                        clearable
                        @change="handleGroupsChange"
                    >
                        <el-option 
                            v-for="item in groupList" 
                            :key="item.id" 
                            :label="item.name" 
                            :value="item.id"
                        />
                    </ESelect>
                </el-form-item>
                
                <el-form-item label="销售人员：" >
                    <ESelect 
                        v-model="formData.user_ids"  
                        clearable  
                        placeholder="下拉选择" 
                        size="mini" 
                        class="select-tags-width" 
                        style="width:100px"
                        @change="getList()"
                    >
                        <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </ESelect>
                </el-form-item>
                 <el-form-item label="产品类型：" >
                    <ESelect 
                        v-model="formData.type"  
                        clearable  
                        placeholder="下拉选择" 
                        size="mini" 
                        multiple
                        collapse-tags
                        class="select-tags-width" 
                        style="width:160px"
                        @change="getList()"
                    >
                        <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </ESelect>
                </el-form-item>
                <el-form-item label="" label-width="0">
                    <el-button v-matomo="{behaviorCategory: '销售负责人', event: '点击',  name: '季度产品(导出)' }" size="mini" :loading="exportLoading" @click="exportData">导出</el-button>
                </el-form-item>
            </el-form>

        </div>
        <div class="data-list">
            <div class="table-tip">
                <span>{{ quarterTip }}</span>
                <span>{{ platName }}</span>
                <span>对应维度下期间内有消耗项目去重数量</span>
            </div>
            <el-table
                v-loading="!exportLoading&& loading"
                :data="dataList"
                stripe
                :border="true"
                a
                :header-cell-style="{background:'#e8eaec',color:'#333'}"
                size="mini">
                <el-table-column
                    prop="group_name"
                    label="销售组"
                    width="150"
                />
                <el-table-column
                    prop="user_name"
                    label="销售人员"
                    width="150"
                />
                <el-table-column
                    prop="type"
                    label="产品类型"
                    width="150"
                />

                <el-table-column
                    prop="project_cnt"
                    label="总项目数量"
                    min-width="120"
                    align="right"
                />
                <el-table-column
                    prop="new_app_cnt"
                    label="新产品数量"
                    min-width="120"
                    align="right"
                />
                <el-table-column
                    prop="new_bloc_cnt"
                    label="新集团新品"
                    min-width="120"
                    align="right"
                />
                <el-table-column
                    prop="new_company_project_cnt"
                    label="新主体新品"
                    min-width="120"
                    align="right"
                />
                <el-table-column
                    prop="old_bloc_cnt"
                    label="老集团新品"
                    min-width="120"
                    align="right"
                />
                <el-table-column
                    prop="old_app_cnt"
                    label="老产品数量"
                    min-width="120"
                    align="right"
                />
                <el-table-column
                    prop="new_app_cnt_rate"
                    label="新品数量占比总数量"
                    min-width="140"
                    align="right"
                />
                <el-table-column
                    prop="diff_project_cnt"
                    label="整体数量变化"
                    min-width="120"
                    align="right"
                />
                <el-table-column
                    prop="diff_project_cnt_rate"
                    label="整体数量变化幅度"
                    min-width="140"
                    align="right"
                />
                <el-table-column
                    prop="diff_new_app_cnt"
                    label="新品数量变化"
                    min-width="120"
                    align="right"
                />
                <el-table-column
                    prop="diff_new_app_cnt_rate"
                    label="新品数量变化幅度"
                    min-width="140"
                    align="right"
                />
                <el-table-column
                    prop="diff_new_bloc_cnt"
                    label="新集团新品变化"
                    min-width="130"
                    align="right"
                />
                <el-table-column
                    prop="diff_new_bloc_cnt_rate"
                    label="新集团新品变化幅度"
                    min-width="130"
                    align="right"
                />
                <el-table-column
                    prop="diff_new_company_project_cnt"
                    label="新主体新品变化"
                    min-width="120"
                    align="right"
                />
                <el-table-column
                    prop="diff_new_company_project_cnt_rate"
                    label="新主体新品变化幅度"
                    min-width="140"
                    align="right"
                />
                <el-table-column
                    prop="diff_old_bloc_cnt"
                    label="老集团新品变化"
                    min-width="120"
                    align="right"
                />
                <el-table-column
                    prop="diff_old_bloc_cnt_rate"
                    label="老集团新品变化幅度"
                    min-width="130"
                    align="right"
                />
                <el-table-column
                    prop="diff_old_app_cnt"
                    label="老品数量变化"
                    min-width="120"
                    align="right"
                />
                <el-table-column
                    prop="diff_old_app_cnt_rate"
                    label="老品数量变化幅度"
                    min-width="130"
                    align="right"
                />
                <el-table-column
                    prop="new_app_cnt_last_rate"
                    label="上季度新品占比"
                    min-width="120"
                    align="right"
                />
                <el-table-column
                    prop="new_company_cnt"
                    label="新主体数量"
                    min-width="120"
                    align="right"
                />
                <el-table-column
                    prop="diff_new_company_cnt"
                    label="新主体数量变化"
                    min-width="130"
                    align="right"
                />
                <el-table-column
                    prop="diff_new_company_cnt_rate"
                    label="新主体数量变化幅度"
                    min-width="140"
                    align="right"
                />
            </el-table>
            <div class="page-bar tar">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="pagination.pn"
                    :page-size="10"
                    :pager-count="5"
                    layout="total, prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import QuarterDate from "@/components/QuarterDate";
import API from '@/api/dashboard'
import dayjs from 'dayjs'
export default {
    name:'QuarterProduct',
    components: { QuarterDate },
    props: {
        platList: {
            type: Array,
        }
    } ,
    data() {
        const date = dayjs().subtract(1, 'quarter')
        return {
            formData: {
                plat_id: '', //默认是OPPO
                quarter: `${date.year() }-${date.quarter()}`,//默认是上一季度
                groups: '',
                user_ids: '',
                type: [],//产品类型
            },
            loading: false,
            pagination: {
                pn: 1,
                rn: 10
            },
            total: 0,
            dataList: [{}],
            exportLoading: false,
            userList: [],
            userLoading: false,
            groupList: [], //销售组
            typeList: [
                { id: 1, name: '整体' },
                { id: 2, name: '应用IAP' },
                { id: 3, name: '应用IAA' },
                { id: 4, name: '快应用' },
            ]
        }
    },
    computed: { 
        filterPlatList() {
            return this.platList.filter(v=> {
                return ['1', '3', '4', '10', '11', '7' ].includes(v.id)
            })
        },
        platName() {
            return this.filterPlatList.find(v=>v.id === this.formData.plat_id)?.name || ''
        },
        quarterTip() {
            return this.formData.quarter.split('-').join("年Q")
        }
    },
    watch: {
        filterPlatList: {
            handler(n) {
                const obj = n.find(v=> v.id === '1');
                let plat_id =''
                if (obj) {
                    plat_id = obj.id
                }else if(n.length>0) {
                    plat_id = n[0].id
                }
                this.formData.plat_id = plat_id;
                this.handleParamsChange()
            },
            immediate: true
        }
    },
    created() {
        // this.handleGroupsChange('')
    },
    methods: {
        // 选择组
        handleGroupsChange(group) {
            Object.assign(this.formData, {
                user_ids: ''
            });
            this.getSaleGroup({
                group,
                search_type: 'user',
            })
            this.pagination.pn = 1;
            this.getList()
        },
        // 选择媒体
        handleParamsChange() {
            Object.assign(this.formData, {
                groups: '',
                user_ids: ''
            })
            this.getSaleGroup();
            this.getSaleGroup({
                group: '',
                search_type: 'user',
            })
           
            this.pagination.pn = 1;
            this.getList()
        },
        handleCurrentChange(pn) {
            this.pagination.pn = pn;
            this.getList()
        },
        async exportData() {
           try {
             this.exportLoading = true
             await this.getList({ export: '1' })
           } catch (error) {}finally {
             this.exportLoading = false
           }
        },
        // 获取组
        async getSaleGroup(p={}) {
            
            try {
                const [ year, quarter ]  = this.formData.quarter.split('-')
                const params = { 
                    plat_id: this.formData.plat_id,  
                    quarter,
                    year,
                    search_type: 'group',
                    ...p
                };
                const { data } = await API.getXsQuarterProjectGroup(params);
                if ('group' in params) {
                    this.userList = data.list
                }else {
                    this.groupList = data.list
                }
            } catch (error) {
                console.log(this.formData, error,111);
            }
        },
        
        // 列表
        async getList(p={}) {
            try {
                this.loading = true;
                const { plat_id, groups, user_ids, type } = this.formData;
                const [ year, quarter ]  = this.formData.quarter.split('-')
                const params = {
                    plat_id, year, quarter, groups, user_ids,
                    type: (type || []).toString(),
                    ...this.pagination,
                    ...p
                }
                const { data, info } = await API.getXsQuarterProjectList(params);
                if (!params.export) {
                    this.dataList = data.list;
                    this.total = data.totalCnt
                }else {
                    // 导出的情况
                    this.$message.success(info)
                }
            } catch (error) {
                this.$message.error(error.info)
            }finally {
                this.loading = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.table-tip {
    margin-bottom: 10px;
    span {
        // display: inline-block;
        padding-right: 30px;
    }
}
.filter-bar {
    ::v-deep .el-form-item{
        margin-bottom: 10px;
    }
    ::v-deep .el-form-item__label{
        padding-right: 0;
    }
}
.data-list {
    ::v-deep .el-table__cell{
        padding: 3px 0;
    }
}
</style>